import {
  AiManagementTypes,
  AiManagementColumn,
  AiManagementFilters,
  AiManagementCard,
} from './types';

export const buildFilterParams = (filters?: AiManagementFilters) => {
  const params: Record<string, unknown> = {};
  if (!filters) return params;

  if (filters.scope === 'mine') params.scope = 'mine';
  else if (filters.memberIds.length) params.member_ids = filters.memberIds;

  if (filters.q.trim()) params.q = filters.q.trim();
  if (filters.deadlineFrom) params.deadline_from = filters.deadlineFrom;
  if (filters.deadlineTo) params.deadline_to = filters.deadlineTo;

  return params;
};

export const getColumns = (filters?: AiManagementFilters) => ({
  types: [
    AiManagementTypes.GET_COLUMNS_REQUEST,
    AiManagementTypes.GET_COLUMNS_SUCCESS,
    AiManagementTypes.GET_COLUMNS_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/gestao_ia/colunas', { params: buildFilterParams(filters) }),
});

export const getCards = (filters?: AiManagementFilters) => ({
  types: [
    AiManagementTypes.GET_CARDS_REQUEST,
    AiManagementTypes.GET_CARDS_SUCCESS,
    AiManagementTypes.GET_CARDS_FAILURE,
  ],
  promise: (client: any) => client.get('/gestao_ia/cards', { params: buildFilterParams(filters) }),
});

interface MoveTaskPayload {
  taskId: number;
  fromColumnId: number;
  toColumnId: number;
  toIndex: number;
}

export const moveTaskLocal = (payload: MoveTaskPayload) => ({
  type: AiManagementTypes.MOVE_TASK,
  payload,
});

export const getTasks = () => ({
  types: [
    AiManagementTypes.GET_TASKS_REQUEST,
    AiManagementTypes.GET_TASKS_SUCCESS,
    AiManagementTypes.GET_TASKS_FAILURE,
  ],
  promise: (client: any) => client.get('/gestao_ia/tarefas'),
});

export const getTeam = () => ({
  types: [
    AiManagementTypes.GET_TEAM_REQUEST,
    AiManagementTypes.GET_TEAM_SUCCESS,
    AiManagementTypes.GET_TEAM_FAILURE,
  ],
  promise: (client: any) => client.get('/gestao_ia/equipe'),
});

export const setFilters = (filters: AiManagementFilters) => ({
  type: AiManagementTypes.SET_FILTERS,
  payload: filters,
});

export const reorderColumns = (columns: AiManagementColumn[]) => ({
  type: AiManagementTypes.REORDER_COLUMNS,
  payload: columns,
});

export const renameColumnLocal = (id: number, name: string) => ({
  type: AiManagementTypes.RENAME_COLUMN,
  payload: { id, name },
});

export const recolorColumnLocal = (id: number, color: string) => ({
  type: AiManagementTypes.RECOLOR_COLUMN,
  payload: { id, color },
});

export const removeColumnLocal = (id: number) => ({
  type: AiManagementTypes.REMOVE_COLUMN,
  payload: { id },
});

interface MoveCardPayload {
  cardId: number;
  fromColumnId: number;
  toColumnId: number;
  toIndex: number;
}

export const moveCardLocal = (payload: MoveCardPayload) => ({
  type: AiManagementTypes.MOVE_CARD,
  payload,
});

export const removeCardLocal = (cardId: number) => ({
  type: AiManagementTypes.REMOVE_CARD,
  payload: { cardId },
});

export const upsertCard = (card: AiManagementCard) => ({
  type: AiManagementTypes.UPSERT_CARD,
  payload: card,
});
